export const GET_ALL_INTEGRATION_SUCCESS = "GET_ALL_INTEGRATION_SUCCESS";
export const GET_ALL_INTEGRATION_LOADING = "GET_ALL_INTEGRATION_LOADING";
export const GET_ALL_SERVICES_SUCCESS = "GET_ALL_SERVICES_SUCCESS";
export const GET_ALL_SERVICES_LOADING = "GET_ALL_SERVICES_LOADING";
export const GET_META_DATA_TYPE = "GET_META_DATA_TYPE";
export const GET_META_DATA_VALUES = "GET_META_DATA_VALUES";
export const UPDATE_FORM_DATA = "UPDATE_FORM_DATA"